import Vue from "vue";
import Vuex from "vuex";
// import $http from "./request.js";

Vue.use(Vuex);

const state = {
  
};

const mutations = {
  clear(state, payload) {
    const key = payload.key;
    if (state[key] instanceof Array){
      state[key] = [];
    } else {
      state[key] = {};
    }
  },
  update(state, payload){
    const key = payload.key;
    if (state[key] instanceof Array){
      state[key] = [
        ...state[key],
        ...payload.value
      ];
    } else {
      state[key] = {
        ...state[key],
        ...payload.value
      };
    }
  }
};

const actions = {
  
};


export default new Vuex.Store({
  state,
  mutations,
  actions
});